import { useRecoilCallback } from "recoil"
import { snapshotUsersInEntityState, usersInEntityState, usersPerSiteState } from "../store/users.store"
import { UserPerSite } from "../../api-client-nswag/custompermission-client"

export const useUsersActions = () => {

  const loadUsersInEntity = useRecoilCallback(
    ({ set }) =>
      (users: UserPerSite[]) => {
        set(usersInEntityState, users)
        set(snapshotUsersInEntityState, users)
      },
    []
  )

  const loadUsersPerSite = useRecoilCallback(
    ({ set }) =>
      (users: UserPerSite[]) => {
        set(usersPerSiteState, users)
      },
    []
  )

  const addUsersToEntity = useRecoilCallback(
    ({ set, snapshot }) =>
      (usersToAdd: UserPerSite[]) => {
        set(usersInEntityState, (prev) => [...prev, ...usersToAdd])
        set(usersPerSiteState, (prev) => prev.filter(u => !usersToAdd.some(add => add.userId === u.userId)))
      },
    []
  )

  const removeUsersFromEntity = useRecoilCallback(
    ({ set }) =>
      (usersToRemove: UserPerSite[]) => {
        set(usersInEntityState, (prev) => prev.filter(u => !usersToRemove.some(r => r.userId === u.userId)))
        set(usersPerSiteState, (prev) => {
          const uniqueIds = new Set(prev.map(u => u.userId));
          const newUsers = usersToRemove.filter(u => !uniqueIds.has(u.userId));
          return [...prev, ...newUsers];
        });
      },
    []
  )

  return {
    loadUsersInEntity,
    loadUsersPerSite,
    addUsersToEntity,
    removeUsersFromEntity,
  }
}
